import React, { Component } from 'react'
import styled, { css, keyframes, createGlobalStyle } from 'styled-components'
import { DefaultText, Icon, FlexWrapper } from './'

const GlobalStyle = createGlobalStyle`
  body{
    #root{
      position: relative;
      overflow:hidden !important;
    }
  }
`
const Overlay = styled.div`
  position: fixed;
  display: block;
  min-width: 100%;
  height: 100%;
  top: ${props => (props.top ? props.top : '0px')};
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: ${props => props.zIndexOverlay || 9999999};
  cursor: pointer;
  max-width: 768px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
`
const fadeInUp = keyframes`
from {
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100%, 0);
  visibility: visible;
}

to {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
`
const fadeInDown = keyframes`
from {
  -webkit-transform: translate3d(0, -100%, 0);
  transform: translate3d(0, -100%, 0);
  visibility: visible;
}

to {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
`
const Div = styled.div`
  padding: 2px 6px;
`

const fadeUp = props =>
  css`
    ${fadeInUp} 0.2s linear;
  `
const fadeDown = props =>
  css`
    ${fadeInDown} 0.2s linear;
  `
const ModalUpWrapper = styled.div`
  animation: ${fadeDown};
  width: 100%;
  padding: ${props => (props.padding ? props.padding : '0 0 20px 0')};
  max-width: ${props => (props.maxWidth ? props.maxWidth : '340px')};
  background-color: #fff;
  /* box-shadow: 0 1px 3px 2px rgba(204, 204, 204, 0.5); */
  display: ${props => (props.show ? 'block' : 'none')};
  margin: 0 auto;
  border-radius: 5px;
  max-height: ${props => (props.maxHeight ? props.maxHeight : '400px')};
  overflow-y: auto;
  ${props =>
    props.list &&
    `
  position: fixed;
  bottom: 59px;
  left: calc(50% - 170px);
  padding: 0px;
  `};
`
const ModalDownWrapper = styled.div`
  animation: ${fadeUp};
  width: 100%;
  padding: ${props => (props.padding ? props.padding : '0 0 20px 0')};
  max-width: ${props => (props.maxWidth ? props.maxWidth : '340px')};
  background-color: #fff;
  /* box-shadow: 0 1px 3px 2px rgba(204, 204, 204, 0.5); */
  display: ${props => (props.show ? 'block' : 'none')};
  margin: 0 auto;
  border-radius: 5px;
  max-height: ${props => (props.maxHeight ? props.maxHeight : '400px')};
  overflow-y: auto;
  z-index: ${props => props.zIndex || 'initial'};
  ${props =>
    props.list &&
    `
  position: fixed;
  bottom: 59px;
  left: calc(50% - 170px);
  padding: 0px;
  `};
`
class Modal extends Component {
  state = {}
  render() {
    const {
      show,
      hide,
      maxWidth,
      children,
      title,
      onClose,
      list,
      viewPadding,
      maxHeight,
      top,
      animate,
      zIndexOverlay,
      zIndex,
      ...props
    } = this.props
    return (
      <React.Fragment>
        {show && (
          <Overlay top={top} zIndexOverlay={zIndexOverlay}>
            <GlobalStyle />
            {animate === 'up' ? (
              <ModalUpWrapper maxWidth={maxWidth} show={show} hide={hide} list={list} maxHeight={maxHeight} {...props}>
                <FlexWrapper
                  direction="row"
                  viewPadding={'11px 16px'}
                  alignItems="center"
                  justifyContent="space-between"
                  backgroundColor="#f5f5f5"
                  borderRadius="5px 5px 0 0"
                  border="0.5px solid #dcdcdc">
                  <DefaultText color="#124b5f" fontWeight={'600'}>
                    {title}
                  </DefaultText>
                  {onClose && (
                    <Div onClick={() => (onClose ? onClose() : null)}>
                      <Icon icon="closeModal" />
                    </Div>
                  )}
                </FlexWrapper>
                <FlexWrapper viewPadding={viewPadding ? viewPadding : '14px 16px 20px'}>{children}</FlexWrapper>
              </ModalUpWrapper>
            ) : (
              <ModalDownWrapper
                zIndex={zIndex}
                maxWidth={maxWidth}
                show={show}
                hide={hide}
                list={list}
                maxHeight={maxHeight}
                {...props}>
                <FlexWrapper
                  direction="row"
                  viewPadding={'11px 16px'}
                  alignItems="center"
                  justifyContent="space-between"
                  backgroundColor="#f5f5f5"
                  borderRadius="5px 5px 0 0"
                  border="0.5px solid #dcdcdc">
                  <DefaultText color="#124b5f" fontWeight={'600'}>
                    {title}
                  </DefaultText>
                  {onClose && (
                    <Div onClick={() => (onClose ? onClose() : null)}>
                      <Icon icon="closeModal" />
                    </Div>
                  )}
                </FlexWrapper>
                <FlexWrapper viewPadding={viewPadding ? viewPadding : '14px 16px 20px'}>{children}</FlexWrapper>
              </ModalDownWrapper>
            )}
          </Overlay>
        )}
      </React.Fragment>
    )
  }
}

export default Modal



// WEBPACK FOOTER //
// ./src/components/Modal.js